export const formatTotal = (n: number) => `$${n.toFixed(2)}`;
